import { FC, useState } from 'react';
import jwt from 'jsonwebtoken';
import styled from 'styled-components';

import { CollectionName } from '@/shared/lib/sj-orm/constants';
// import { useSJDatabase } from '@/shared/lib/sj-orm/hooks/use-sj-database';
import { BaseDto } from '@/shared/lib/sj-orm/models/base.dto';
import { useSecureJsonCollectionsStore } from '@/shared/lib/sj-orm/stores/secureJsonCollections.store';
/**
  - Collections
    - Log console
  - Synchronizer
    - state
    - jobs
*/
const prepareItem = ({ id, createdAt, updatedAt, ...data }: BaseDto) => ({
  id,
  createdAt,
  updatedAt,
  ...data,
});

export const TabCollections: FC = () => {
  // const sjdbStore = useSJDatabase();
  const sjcStore = useSecureJsonCollectionsStore();
  // const syncQueueStore = useSyncQueueStore();
  const [colName, setColName] = useState<CollectionName>(CollectionName.ASSETS);
  const [itemId, setItemId] = useState<string | null>(null);

  const collection = sjcStore.collections.get(colName);
  const colItems = collection?.items ? Array.from(collection?.items).slice(0, 100) : [];
  const colItem = itemId ? collection?.getItem(itemId) : null;
  const colItemView = colItem ? prepareItem(colItem.decryptedData) : null;
  const jwtData = colItem?.signature ? jwt.decode(colItem.signature) : null;

  const handleChangeCol = (name: CollectionName) => {
    setColName(name);
    setItemId(null);
  };

  return (
    <Container>
      <ColNames>
        {collections.map((name) => {
          const size = sjcStore.collections.get(name)?.size() ?? 0;

          return (
            <ColName onClick={() => handleChangeCol(name)} key={name}>
              <Name>{name}</Name>
              <Count>({size})</Count>
            </ColName>
          );
        })}
      </ColNames>
      <ColItems>
        {colItems &&
          colItems.map(([id]) => {
            const idChunks = id.split('-');

            return (
              <ColId onClick={() => setItemId(id)} key={id}>
                {idChunks[1]}...{idChunks[5]}
              </ColId>
            );
          })}
      </ColItems>
      <ItemContainer>
        <ItemData>{colItemView && JSON.stringify(colItemView, null, ' ')}</ItemData>
        <ItemSignature>{JSON.stringify(jwtData, null, ' ')}</ItemSignature>
      </ItemContainer>
    </Container>
  );
};

const collections = [
  CollectionName.ASSETS,
  CollectionName.PERSONAL_IDENTIFIERS_DOCUMENTS,
  CollectionName.PRIVATE_DOCUMENTS,
  CollectionName.BENEFICIARIES,
  CollectionName.CONTACTS,
  CollectionName.INTERWILLS,
  CollectionName.SCENARIO_META_INFO,

  CollectionName.INBOX,
  CollectionName.FILE_META_INFO,
  CollectionName.ENCRYPTED_FILE_KEY,
  CollectionName.NOTIFICATION,

  // CollectionName.BENEFICIARY_PERSONAL_DATA_DOCUMENT,
  // CollectionName.ASSET_INFORMATION_DOCUMENT,
];

// #region styled
const Container = styled.div`
  display: grid;
  grid-template-columns: 200px calc(100% - 200px);
  grid-template-rows: 40px 1fr;
  gap: 8px;
`;

const ColNames = styled.div`
  grid-area: 1 / 1 / 2 / 3;

  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  gap: 12px;
`;

const ColItems = styled.div`
  grid-area: 2 / 1 / 3 / 2;

  display: flex;
  flex-direction: column;
  gap: 12px;
`;

const ItemContainer = styled.div`
  grid-area: 2 / 2 / 3 / 3;

  display: flex;
  gap: 8px;
  // overflow: hidden;

  flex-direction: row;

  @media screen and (max-width: 1000px) {
    flex-direction: column;
  }
`;

// #region components
const ColName = styled.span`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 4px;
  cursor: pointer;
`;

const ColId = styled.div`
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  cursor: pointer;
`;

const Name = styled.div`
  max-width: 120px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const Count = styled.div`
  // width: 32px;
  // text-align: right;
`;

const ItemData = styled.pre`
  flex: 1;
  padding: 8px;
  border: 1px solid rgba(0, 0, 0, 0.3);
  border-radius: 8px;
  overflow-y: auto;
`;

const ItemSignature = styled.pre`
  width: 380px;
  height: 200px;
  padding: 8px;
  border: 1px solid rgba(0, 0, 0, 0.3);
  border-radius: 8px;
  overflow-y: auto;
`;
